import Vue from 'vue';
import moment from 'moment';
import _ from 'lodash';

Vue.filter('dateFormat', function(value, format) {
  if (!value) {
    return '-';
  }
  return Number(value) ? moment(value, 'X').format(format ? format : 'YYYY-MM-DD HH:mm:ss') : value;
});
Vue.filter('dateFormatYMD', function(value, format) {
  if (!value) {
    return '-';
  }
  return Number(value) ? moment(value, 'X').format(format ? format : 'YYYY-MM-DD') : value;
});

//t => v
Vue.filter('tTov', (val, data) => {
  let str = '';
  if ((data && data.length == 0) || !val) {
    str = '';
  } else if (typeof val == 'string') {
    _.map(data, (item) => {
      if (item.t == val) {
        str = item.t;
      }
    });
  } else {
    _.map(data, (item) => {
      if (item.v == val) {
        str = item.t;
      }
    });
  }
  return str;
});
